import { useMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { mpeApi } from '@retail/mgpris/config';
import { MgItemCalculationDTO } from '@retail/my-assortment/types';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

interface Props extends QueryOptions {
  assortmentId: number;
  mgItemNumber: number;
}

export function useFetchMgItemCalculation({ assortmentId, mgItemNumber, ...queryOptions }: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<MgItemCalculationDTO>({
    method: 'GET',
    queryKey: ['calculusCard', assortmentId, mgItemNumber],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.assortmentPrices.assortment.calculation.mgItem.getFullLinkPath({
        assortmentId,
        mgItemNumber,
      }),
    }),
    ...queryOptions,
  });
}
